import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { checkVersion } from '@/utils/RefreshPage'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/index'),
    redirect:'add/index',
    children:[
      // 首页提交申请
      {
        path: "/add/index",
        component: () => import("@/views/add/index"),
        meta: { title: "医生医技档案" ,type:1},
      },
      {
        path: "/add/addDetail",
        component: () => import("@/views/add/addDetail"),
        meta: { title: "医生医技档案" ,type:1},
      },
      // 进修记录
      {
        path: "/record/index",
        component: () => import("@/views/record/index"),
        meta: { title: "进修记录" ,type:2},
      },
      // 院内报到
      {
        path: "/report/index",
        component: () => import("@/views/hospitalReport/index"),
        meta: { title: "院内报到" ,type:3},
      },
      {
        path: "/report/certificate",
        component: () => import("@/views/hospitalReport/certificate"),
        meta: { title: "院内报到" ,type:3},
      },
      // 进修过程
      {
        path: "/process/index",
        component: () => import("@/views/process/index"),
        meta: { title: "进修过程登记" ,type:4},
      },
      {
        path: "/process/absenteeism",
        component: () => import("@/views/process/absenteeism"),
        meta: { title: "缺勤登记" ,type:4},
      },
      {
        path: "/process/diagnosis",
        component: () => import("@/views/process/diagnosis"),
        meta: { title: "参加诊断治疗" ,type:4},
      },
      {
        path: "/process/study",
        component: () => import("@/views/process/study"),
        meta: { title: "参加诊断治疗" ,type:4},
      },
      {
        path: "/process/operation",
        component: () => import("@/views/process/operation"),
        meta: { title: "参加手术操作情况" ,type:4},
      },
      // 进修考核
      {
        path: "/examine/index",
        component: () => import("@/views/examine/index"),
        meta: { title: "进修考核" ,type:5},
      },
      {
        path: "/examine/detail",
        component: () => import("@/views/examine/detail"),
        meta: { title: "进修考核" ,type:5},
      },
      {
        path: "/examine/nursedetail",
        component: () => import("@/views/examine/nursedetail"),
        meta: { title: "进修考核" ,type:5},
      },
      // 离院登记
      {
        path: "/leave/index",
        component: () => import("@/views/leaveHospital/index"),
        meta: { title: "离院登记" ,type:6},
      },
      {
        path: "/leave/detail",
        component: () => import("@/views/leaveHospital/detail"),
        meta: { title: "离院登记" ,type:0},
      },
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login')
  },
  {
    path: "/register",
    component: () => import("@/views/register"),
  },
  {
    path: "/retrieve",
    component: () => import("@/views/retrieve"),
  },
  {
    path: "/specialist/list",
    component: () => import("@/views/otherPage/Specialist/list"),
  },
  {
    path: "/specialist/detail",
    component: () => import("@/views/otherPage/Specialist/detail"),
  },
  {
    path: "/preview",
    component: () => import("@/views/otherPage/preview"),
  },
  {
    path: "/previewNotice",
    component: () => import("@/views/otherPage/previewNotice"),
  },
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  checkVersion() // 检测版本号
  let list  = ['/login','/register','/retrieve']
  if(list.includes(to.path)){
    let token = getToken()
    if(token){
      next('/add/index')
    }else{
      next()
    }
  }else{
    next()
  }
})
// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

export default router
